import React from "react";
import { provider, auth } from "../../Environment/firebase";
import { getRedirectResult } from "firebase/auth";
import { useAuthContext } from "../../Modules/Auth/AuthContext";
import { useNavigate } from "react-router-dom";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { Card } from "@mui/material";
import { CardContent } from "@mui/material";
import GoogleIcon from "../../Images/google_logo_icon_169090.png";
import Modal from "@mui/material/Modal";
import { CircularProgress } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export function Login(): JSX.Element {
  const [modalOpen, setModalOpen] = React.useState<boolean>(false);
  const navigation = useNavigate();
  const { agree } = useAuthContext();

  // const login = () => {
  //   setModalOpen(true);
  //   // [START auth_google_provider_scopes]
  //   //provider.addScope("https://www.googleapis.com/auth/contacts.readonly");
  //   // [END auth_google_provider_scopes]
  //   auth.languageCode = "ja";

  //   // [START auth_google_provider_params]

  //   provider.setCustomParameters({
  //     hd: "mnes.org",
  //   });
  //   const isLocalhost = window.location.hostname === "localhost";

  //   // [END auth_google_provider_params]
  //   if (isLocalhost) {
  //     auth.signInWithPopup(provider);
  //   } else {
  //     auth.signInWithRedirect(provider);
  //   }
  // };

  const login = async () => {
    setModalOpen(true);
    auth.languageCode = "ja";

    try {
      const result = await auth.signInWithPopup(provider);
      console.log("✅ ログイン成功:", result.user?.email);

      if (result.user) {
        if (agree) {
          navigation("/");
        } else {
          navigation("/forms");
        }
      }
    } catch (error) {
      console.error("❌ ログイン失敗:", error);
      setModalOpen(false);
    }
  };

  React.useEffect(() => {
    // ログイン済みであればすぐに遷移
    if (auth.currentUser) {
      console.log("✅ すでにログイン済み:", auth.currentUser.email);
      if (agree) {
        navigation("/");
      } else {
        navigation("/forms");
      }
      return; // それ以上の処理は不要なのでここで終了
    }

    // まだログインされていない場合は getRedirectResult を試みる
    console.log("getRedirectResult: starting");

    getRedirectResult(auth)
      .then((result) => {
        console.log("✅ getRedirectResult result:", result);

        if (result && result.user) {
          console.log("User is signed in via redirect:", result.user.email);
          if (agree) {
            navigation("/");
          } else {
            navigation("/forms");
          }
        } else {
          console.log(
            "No user from redirect, maybe already handled or cancelled."
          );
        }
      })
      .catch((error) => {
        console.error("getRedirectResult error:", error);
      });
  }, []);

  // React.useEffect(() => {
  //   getRedirectResult(auth)
  //     .then((result) => {
  //       if (result !== null) {
  //         //const credential = GoogleAuthProvider.credentialFromResult(result);
  //         //const token = credential.accessToken;
  //         // The signed-in user info.
  //         const user = result.user;
  //         if (user) {
  //           if (agree) {
  //             navigation("/");
  //           } else {
  //             navigation("/forms");
  //           }
  //         } else {
  //           navigation("/login");
  //         }
  //       } else {
  //         //navigation("/login");
  //       }
  //     })
  //     .catch((error) => {
  //       // Handle Errors here.
  //       //const errorCode = error.code;
  //       //const errorMessage = error.message;
  //       //const email = error.email;
  //       // The AuthCredential type that was used.
  //       //const credential = GoogleAuthProvider.credentialFromError(error);
  //     });
  // }, []);

  return (
    <div>
      <Container component="main" maxWidth="md" sx={{ mt: 3 }}>
        <Card sx={{ mt: 3 }}>
          <CardContent>
            <Box
              sx={{
                marginTop: 8,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
                <LockOutlinedIcon />
              </Avatar>
              <Typography component="h1" variant="h5">
                Msta ログイン画面
              </Typography>
              <Typography component="div" variant="subtitle1" sx={{ mt: 2 }}>
                Mstaサービスをご利用するにはログインが必要です。
              </Typography>
              <Typography component="div" variant="body1">
                ※ログインにはGoogleアカウントが必要です。
              </Typography>
              <div>
                <Grid container spacing={2} sx={{ mt: 3 }}>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      fullWidth
                      onClick={login}
                      variant="outlined"
                      sx={{ mt: 3, mb: 2 }}
                    >
                      <Grid
                        display="flex"
                        alignItems="center"
                        justifyItems="center"
                        gap={3}
                      >
                        <img
                          src={GoogleIcon}
                          width={40}
                          height={40}
                          alt="sing in with google"
                        ></img>
                        <Typography component="div" variant="body1">
                          googleでログイン
                        </Typography>
                      </Grid>
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      fullWidth
                      onClick={() => navigation("/")}
                      variant="contained"
                      sx={{ mt: 3, mb: 2 }}
                    >
                      HOME
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </Box>
          </CardContent>
        </Card>
        <Modal
          open={modalOpen}
          //onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Typography id="modal-modal-title" variant="h6" component="h2">
              リダイレクト中です。
            </Typography>
            <Grid display={"flex"} gap={2}>
              <CircularProgress></CircularProgress>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                通信環境の良い場所で行ってください。
              </Typography>
            </Grid>
          </Box>
        </Modal>
      </Container>
    </div>
  );
}
